
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/catradio/notes-de-premsa",
      function () {
        return require("private-next-pages/corporatiu/premsa/catradio/notes-de-premsa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/catradio/notes-de-premsa"])
      });
    }
  